import React, { useEffect, useState } from "react";
import "./Searchhome.css";
import searchicon from "../../Images/searchicon.png";
import { useNavigate } from "react-router-dom";
import close from "../../Images/close.png";
import HttpClient from "../../utils/HttpClient";
import useUserCountry from "../../utils/useUserCountry";
// import { Helmet } from "react-helmet-async";
import SeoGeneral from '../BusinessPage/SeoGeneral';
import JsonLd from "../BusinessListing/components/JsonLd";

const Searchhome = () => {
  const [text, setText] = useState("");
  const navigate = useNavigate();
  const [backgroundImage, setBackgroundImage] = useState("")
  const { country, region, ip } = useUserCountry();

  const searchresultclick = async () => {
    if (text && text.trim() !== "" && text.length >= 3) {
      let data = {
        searchCountry: country,
        // searchCountry: '',
        searchRegion: region,
        searchIp: ip,
        searchName: text,
        page: 1,
        limit: 20
      };
      const response = await HttpClient.requestData("search-business", "POST", data);
      if (response?.status) {
        navigate("/search", {
          state: {
            searchCountry: country,
            // searchCountry: '',
            searchRegion: region,
            searchIp: ip,
            searchText: text,
            data: response?.data,
            pagination: response?.pagination,
            relatedResults: response?.relatedResults
          },
        });
      } else {
        console.log("Error while fetching the data ");
      }
    }
  };

  const handleKeyDown = (event) => {
    setText(event.target.value);
    if (event.key === "Enter") {
      searchresultclick()
    }
  };

  const handleChange = (e) => {
    setText(e.target.value);
  };

  const getBackgroundImage = async () => {
    const response = await HttpClient.requestData("home-background-image", "GET",);
    if (response?.status) {
      setBackgroundImage(response.data[0].image)
    } else {
      console.log("Error while fetching the data ");
    }
  };

  useEffect(() => {
    getBackgroundImage()
  }, [])

  const seoMetaData = {
    title: "Neoo Search – List Your Business Today | 50% Off ",
    description: "List your business on Neoo Search, an SEO-friendly online business directory. Connect with customers and grow your network across UAE, India, and GCC.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "Neoo Search – List Your Business Today | 50% Off",
    url: process.env.REACT_APP_APPLICATION_URL + "/",
    keywords: "Online business directory, Free Digital business card, B2B networking, Lead generation, Business reward program, Digital marketing solution, Business opportunities",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL
  };

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "NeooSearch",
    url: process.env.REACT_APP_APPLICATION_URL,
  };

  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <JsonLd data={schema} />
      <section className="searchhomemain"
        style={{ backgroundImage: `url("${backgroundImage}")` }}
      >
        <div className="cust_container">
          <div className="midownseacrhmaindivnew">
            <div className="logedserchfrminptnew">
              <input
                type="text"
                value={text}
                onChange={handleChange}
                onKeyDown={(event) => handleKeyDown(event)}
                placeholder="Search and drive more leads"
                className="logedserchfrminptinptnew"
                style={{ paddingRight: "70px" }}
              />
              {text && (
                <div
                  className="searchiconimgnew"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10%",
                    cursor: "pointer",
                    right: "45px",
                  }}
                  onClick={() => setText("")}
                >
                  <img
                    style={{
                      height: "13px",
                      width: "13px",
                    }}
                    src={close}
                    alt="closing button"
                  />
                </div>
              )}
              <div className="searchiconimgnew" onClick={searchresultclick}>
                <img src={searchicon} alt="..." />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Searchhome;
